const S3URL = () => "https://s3.us-east-2.amazonaws.com/wp.uggcms/wp-content";

export const rewriteWPImageUrlToS3 = (imgUrl?: string | null): string => {
  if (!imgUrl) return "";
  const imagePath = imgUrl.includes("wp-content") ? imgUrl.split("wp-content")[1] : "";
  return process.env.UGG_PUBLIC_ARTICLE_ROUTING !== "dev" && imagePath ? `${S3URL()}${imagePath}` : imgUrl;
};

export function getArticleUrl(slug: string) {
  const articleRouting = process.env.UGG_PUBLIC_ARTICLE_ROUTING as "dev" | "dugg" | "bugg" | "prod" | undefined;

  let base: string;
  switch (articleRouting) {
    case "dev":
      base = "http://localhost:3000";
      break;
    case "dugg":
      base = "https://d.u.gg";
      break;
    case "bugg":
      base = "https://b.u.gg";
      break;
    case "prod":
    default:
      base = "https://u.gg";
  }

  return `${base}/lol/news/${slug}`;
}
